import date from 'quasar/src/utils/date.js';;

export default {
  data() {
    return {
        statusMap: {
          pending: { key: 'pending', color: 'orange' },
          accepted: { key: 'accepted', color: 'positive' },
          rejected: { key: 'rejected', color: 'negative' },
          cancelled: { key: 'cancelled', color: 'primary' },
          completed: { key: 'completed', color: 'info' },
        },
      currencySymbols: {
        PLN: 'zł',
        EUR: '€',
        USD: '$',
      },
    };
  },
  methods: {
    getCurrencySymbol(currencyCode) {
      return this.currencySymbols[currencyCode] || currencyCode;
    },
    formatDate(dateString) {
      return date.formatDate(dateString, 'YYYY-MM-DD');
    },
    getStatusLabel(statusKey) {
      return this.$t(
        `bookings.status.${this.statusMap[statusKey]?.key}` ||
          'bookings.status.unknown'
      );
    },
    getStatusColor(statusKey) {
      return this.statusMap[statusKey]?.color || 'grey';
    },
    displayNameOrUsernameFallback(user) {
      if (!user) return '';
      const first = user.first_name?.trim();
      const last = user.last_name?.trim();
      if (first || last) {
        return `${first || ''} ${last || ''}`.trim();
      }
      return user.name || '';
    },
    formatCalendarDate(timestamp) {
      return `${timestamp.year}-${String(timestamp.month).padStart(
        2,
        '0'
      )}-${String(timestamp.day).padStart(2, '0')}`;
    },
    isToday(timestamp) {
      const today = new Date();
      return (
        timestamp.year === today.getFullYear() &&
        timestamp.month === today.getMonth() + 1 &&
        timestamp.day === today.getDate()
      );
    },
    filterBookingsByStatus(bookings, status) {
      if (!status) return bookings;
      return bookings.filter((b) => b.status === status);
    },
    saveStatusFilter(status) {
      localStorage.setItem('bookingStatusFilter', status || '');
    },
    loadStatusFilter() {
      return localStorage.getItem('bookingStatusFilter') || null;
    },
    getStatusOptions() {
      const options = Object.keys(this.statusMap).map((key) => ({
        label: this.getStatusLabel(key),
        value: key,
      }));

      options.unshift({ label: this.$t('bookings.status.all'), value: null });

      return options;
    },
  },
};
